import { Api } from '../modules/Service';

const MInventoryItem = {
  list: () => {
    return Api('/stock_item/list');
  },
  add: data => {
    return Api('/stock_item/new', JSON.stringify(data), 'POST', 'text');
  },
  update: data => {
    return Api(
      '/stock_item/set/' + data.id,
      JSON.stringify(data),
      'POST',
      'text',
    );
  },
  delete: id => {
    return Api('/stock_item/del/' + id, {}, 'GET', 'text');
  },
  get: id => {
    return Api('/stock_item/get/' + id);
  },
};
export default MInventoryItem;
